import { Col, Container, Row } from "react-bootstrap"
import { graphql, useStaticQuery, Link } from "gatsby"

import { BaseBlockContent } from "@utils/richText"
import { ConfirmBanner } from "@utils/globalTypes"
import React from "react"
import * as s from "./Banner.module.scss"
import { getGatsbyImageData } from "gatsby-source-sanity"
import { GatsbyImage } from "gatsby-plugin-image"
import { sanity } from "../../../../client-config"

type Props = {
  banner: any
}

const Banner = ({ banner = null }: Props) => {
  const { dataset, projectId } = sanity
  const { sanityTestConfirmBanner, appStoreImg, googlePlayImg } =
    useStaticQuery<{
      sanityTestConfirmBanner: ConfirmBanner
      appStoreImg
      googlePlayImg
    }>(bannerQuery)

  const fluidProps =
    banner?.image &&
    getGatsbyImageData(
      banner.image.asset._id,
      { placeholder: "blurred", fit: "fill" },
      { dataset, projectId }
    )
  const stores = banner ? banner?.store : sanityTestConfirmBanner?.stores

  return (
    <Container>
      <div className={s.container}>
        <Row className={s.rowContent}>
          <Col md={4}>
            {fluidProps ? (
              <figure>
                <GatsbyImage image={fluidProps} alt={banner.image.alt} />
              </figure>
            ) : (
              sanityTestConfirmBanner.image &&
              sanityTestConfirmBanner.image.asset && (
                <div className={s.image}>
                  <GatsbyImage
                    style={{ maxHeight: 210 ,maxWidth: 435 }}
                    imgStyle={{ objectFit: "contain", borderRadius: 15 }}
                    alt={sanityTestConfirmBanner.image.alt}
                    image={sanityTestConfirmBanner?.image?.asset?.gatsbyImageData}
                  />
                </div>
              )
            )}
          </Col>
          <Col md={7} xs={12}>
            <div className={s.descriptionContainer}>
              <div className={s.description}>
                <BaseBlockContent
                  blocks={
                    banner?.text
                      ? banner?.text
                      : sanityTestConfirmBanner?._rawText
                  }
                />
              </div>
              {sanityTestConfirmBanner?.button && (
                <Col className={s.storesIcons}>
                  <Link
                    to={sanityTestConfirmBanner.button.link}
                    className={s.storeLink}
                  >
                    {sanityTestConfirmBanner?.button?.label}
                  </Link>
                </Col>
              )}
            </div>  
          </Col>
          {banner?.stores ||
            (!banner && (
              <Col className={s.storesIcons}>
                {stores?.map(({ label, image, link }, index) => (
                  <a
                    key={index}
                    href={link}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={s.storeLink}
                  >
                    <GatsbyImage
                      className={s.storeImg}
                      image={
                        image?.asset
                          ? image?.asset?.gatsbyImageData
                          : label === "AppStore"
                          ? appStoreImg?.childImageSharp?.gatsbyImageData
                          : googlePlayImg?.childImageSharp?.gatsbyImageData
                      }
                      alt={label}
                    />
                  </a>
                ))}
              </Col>
            ))}
        </Row>
      </div>
    </Container>
  )
}

const bannerQuery = graphql`
  query {
    sanityTestConfirmBanner {
      _rawText
      image {
        alt
        asset {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      button {
        link
        label
      }
      stores {
        link
        label
        image {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
    }
    appStoreImg: file(relativePath: { eq: "app-stores/app-store-badge.png" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
    googlePlayImg: file(
      relativePath: { eq: "app-stores/google-play-badge.png" }
    ) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED)
      }
    }
  }
`

export default Banner
